import {
  AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild, Inject, NgZone, ChangeDetectionStrategy, ElementRef, Renderer2, SimpleChanges, OnChanges
} from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { VariablesService, UtilService, VwoService, EventsService } from '../../../../shared/services';
import { IFundraiser } from '../../../../fundraiser/models/fundraiser.model';

@Component({
  selector: 'app-fr-tabs',
  templateUrl: './fr-tabs.component.html',
  styleUrls: ['./fr-tabs.component.scss'],
  // encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FrTabsComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() public about;
  @Input() public comments;
  @Input() public supporters;
  @Input() public fundraiser: IFundraiser;
  @Input() public updates;
  @Input() public isFundraiserEnded;
  @Input() public basicInfo;
  @Input() public isLoading;
  @Input() public donateBtnLabel;
  @Input() public sharedCounts;
  @Input() public isDonated;
  @Input() public customTag;
  @Input() public documents;
  @Input() public updateCounts;
  @Input() public team;
  @Input() public donationCard;
  @ViewChild('tabs', { static: true }) tabs: MatTabGroup;
  @ViewChild('sharebtns') sharebtns: ElementRef<HTMLElement>;
  @Output() activeTab = new EventEmitter();
  @Output() headerSticky = new EventEmitter();
  selectedTab;
  preLabel;
  el: HTMLElement;
  isMobile: any;
  isHeaderSticky: boolean;
  visitedTabs: any[] = [];
  counts;
  userData;

  constructor(
    public utilService: UtilService,
    private variablesService: VariablesService,
    // @Inject(WINDOW) private window: Window,
    private renderer: Renderer2,
    public vwo: VwoService,
    private events: EventsService
    // private zone: NgZone
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
    this.variablesService.commentTabSwitch.subscribe({
      next: res => {
        if (res !== this.selectedTab) {
          this.setTab(res);
        }
      }
    });
    this.variablesService.userData.subscribe(res => {
      this.userData = res;
    });
  }
  ngAfterViewInit() {
    if (this.utilService.isBrowser) {
      this.onWindowScroll();
    }
    // if (this.isFundraiserEnded) {
    //   setTimeout(() => {
    //     this.setTab('Updates');
    //   }, 0);
    // }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.comments) {
      this.getCounts(this.comments)
    };
  }

  onWindowScroll() {
    // fromEvent(this.window, 'scroll').subscribe((_event) => {
    this.renderer.listen('window', 'scroll', (_event) => {
      if (this.tabs && this.tabs._elementRef && this.tabs._elementRef.nativeElement && this.sharebtns && this.sharebtns.nativeElement) {
        const data = this.tabs._elementRef.nativeElement.getBoundingClientRect();
        if (data.top <= 0) {
          if (!this.isMobile) {
            this.tabs._elementRef.nativeElement.children[0].classList.add('sticky-header');
            this.sharebtns.nativeElement.style.display = 'inline';
          }
          this.isHeaderSticky = true;
          this.headerSticky.next(true);
        } else {
          if (!this.isMobile) {
            this.tabs._elementRef.nativeElement.children[0].classList.remove('sticky-header');
            this.sharebtns.nativeElement.style.display = 'none';
          }
          this.isHeaderSticky = false;
        }
        if (this.isMobile) {
          this.tabs._elementRef.nativeElement.children[1].style.marginTop = data.top < 10 ? '40px' : '0px';
        } else {
          this.tabs._elementRef.nativeElement.children[1].style.marginTop = data.top <= 0 ? '70px' : '0px';
        }
      }
    });
  }

  /**Tab change event */
  tabChangeEvent(event) {
    if (this.utilService.isBrowser && this.tabs && this.tabs._elementRef && this.tabs._elementRef.nativeElement) {
      const currentLabel = event.tab.textLabel;
      if (this.visitedTabs.indexOf(currentLabel) === -1) {
        this.visitedTabs.push(currentLabel);
      }
      this.activeTab.emit(currentLabel);
      this.selectedTab = event.index;
      this.tabs._elementRef.nativeElement.scrollIntoView(
        { behavior: 'instant', block: 'start', inline: 'nearest' }
      );
      this.tabs._elementRef.nativeElement.children[1].classList.add(currentLabel);
      if (this.preLabel) {
        this.tabs._elementRef.nativeElement.children[1].classList.remove(this.preLabel);
      }
      this.preLabel = currentLabel;
    }
    if (event?.tab?.textLabel === 'Updates') {
      this.events.sendSystemEvent({
        eventName: 'update_tab_opened',
        info_1: this.userData?.id || '',
      }).subscribe(_=>_);
    }
  }
  /**Get the selected tab details */
  getTabFromAbout(event) {
    this.setTab(event);
  }
  /** Set tab to required tab
   * */
  setTab(tabLabel) {
    this.tabs._tabs.forEach((tab) => {
      if (tab.textLabel === tabLabel) {
        this.selectedTab = tab.position;
      }
    });
  }
  /**Check the length of the array */
  checkLength(arr) {
    return arr && arr.length ? true : false;
  }
  /**Get the length */
  getCounts(arr) {
    this.counts =  arr ? arr.total : 0;
  }
  /**Check the team tab condtion */
  checkTeam(arr) {
    if (arr && arr.length) {
      return this.fundraiser && this.fundraiser.parent_cause_id === 49 ? true : false;
    }
  }
  /**Check if the tabs is already loaded then
   * do not re initialize it, by send the label of the tab
   */
  checkForVisitedTabs(label) {
    return this.visitedTabs.indexOf(label) === -1 ? false : true;
  }
}
